import { createApp } from 'vue'
import store from './store'
import VConsole from 'vconsole'
import App from './App.vue'
import router from './router'
// 引入全局样式
import '@/styles/index.scss'
import './app.scss'
// 全局引入按需引入UI库 vant
// import { vantPlugins } from './plugins/vant'
const app = createApp(App)
window.vm = app

if (!import.meta.env.PROD) {
	new VConsole({ theme: 'light' })
}

// 自定义指令
app.directive('cursorLast', {
	mounted: function (el) {
		el.addEventListener('click', function () {
			// 找到最后一个输入框
			const inputFields = el.querySelectorAll('input')
			const lastInput = inputFields[inputFields.length - 1]
			// 将光标移动到最后一个输入框
			lastInput.focus()
			lastInput.setSelectionRange(lastInput.value.length, lastInput.value.length)
		})
	}
})

app.use(store)
// app.use(vantPlugins)
app.use(router)

app.mount('#app')
